import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { Subject as SubjectModel } from './subject/subject.model';
import { map, withLatestFrom } from 'rxjs/operators';
import { UIStateService } from 'src/app/ui-state.service';

@Component({
  selector: 'mea-subjects',
  templateUrl: './subjects.component.html',
  styleUrls: ['./subjects.component.css']
})
export class SubjectsComponent implements OnInit {
  @HostBinding('class') cssClass = 'board__subjects';
  subjects$: any;
  activity: string;

  constructor(private uiState: UIStateService) { }

  ngOnInit() {
    const activitySubjects$ = this.uiState.activitySubjects$;

    this.subjects$ = this.uiState.subjectList$.pipe(
      withLatestFrom(activitySubjects$),
      map(([subjects, activitySubjects]: [any, string]) => {
        if (!subjects) {
          return;
        }
        this.activity = activitySubjects;
        return subjects;
      })
    );
  }

  profession(hierarchy) {
    const profession = hierarchy.substr(0, 2);

    const PROFESSIONS = {
      '03': { name: 'מתמטיקה', hierarchy: '03' },
      '05': { name: 'אנגלית', hierarchy: '05' },
      '07': { name: 'מדעים', hierarchy: '07' },
      '01': { name: 'לשון', hierarchy: '01' },
      '06': { name: 'היסטוריה', hierarchy: '06' },
      '04': { name: 'תנך', hierarchy: '04' },
      '02': { name: 'אזרחות', hierarchy: '02' },
    };

    return PROFESSIONS[profession];
  }
}
